import Checkbox from './Checkbox/';
import CheckboxGroup from './CheckboxGroup/';
import DatePicker from './DatePicker/';
import TimePicker from './TimePicker/';
import FormGroup from './FormGroup/';
import RadioButton from './RadioButton/';
import StarRate from './StarRate/';
import Select from './Select/';
import SelectCreatable from './SelectCreatable/';
import Text from './Text/';
import Textarea from './Textarea/';
import Textarea2 from './Textarea2/';
import InputDate from './InputDate/';
import Wysiwyg from './Wysiwyg/';

module.exports = {
  Checkbox,
  CheckboxGroup,
  DatePicker,
  TimePicker,
  FormGroup,
  RadioButton,
  StarRate,
  Select,
  SelectCreatable,
  Text,
  Textarea,
  Wysiwyg,
  InputDate,
  Textarea2,

};



// WEBPACK FOOTER //
// ./components/FormElements/index.js